// Display-order toggle for the Asset Overview list. Sorting never mutates the
// underlying dataset.
export enum AssetSortOrder {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}
